import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PlatformService } from './platform.service';
import { debounceTime, map } from 'rxjs/operators';
import { GlobalEventsService } from './global-events.service';
import { UntilDestroy } from 'ngx-unificator/decorator';

export interface WindowSize {
  width: number | any;
  height: number | any;
}

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})

export class WindowSizeService {
  private _platform = inject(PlatformService);
  private _events = inject(GlobalEventsService);


  public readonly newWindowSize = new BehaviorSubject<WindowSize>({
    width: this._platform.isBrowser ? (window as any).innerWidth : null,
    height: this._platform.isBrowser ? (window as any).innerHeight : null
  } as WindowSize);

  constructor() {
    if (this._platform.isBrowser) {
      this._events.resize$.pipe(
        debounceTime(100),
        map(event => <WindowSize> {
          width: (<any>window).innerWidth,
          height: (<any>window).innerHeight
        })
      ).subscribe((windowSize) => this.newWindowSize.next(windowSize));
    }
  }
}
